import { useProIndicator } from 'containers/ProIndicator';

export default function useEpisodeTranscriptionProIndicator() {
  return useProIndicator({
    feature: 'fullEpisodeTranscript',
  });
}
